import axios, { AxiosError, AxiosRequestConfig } from "axios";

import { refreshToken } from "@api/app";
import { logAxiosError } from "@api/helpers";
import axiosApiInstance from "@api/HttpClient";
import { InterceptorErrorHandler } from "@api/interceptors/types";
import { handleSSOLogout } from "@api/utils";
import authService from "@lib/services/AuthService";
import { useUIStore } from "@stores";
import { parseAccessToken } from "@utils/helpers";

let isRefreshingToken = false;

export const tokenExpiration: InterceptorErrorHandler = async (error: AxiosError) => {
  const { getState: getUIStoreState } = useUIStore;
  const { showSessionExpirationModal, setShowSessionExpirationModal, setShowTermsModal } =
    getUIStoreState();
  const originalRequest = error?.config as AxiosRequestConfig & { _retry?: boolean };
  const errorResponse = error?.response;
  const responseStatus = errorResponse?.status;
  const token = authService.getAccessToken();
  const decodeToken = token ? parseAccessToken(token) : null;
  const isSSOLogin = decodeToken?.sub.is_sso_login;
  const tokenExpired = responseStatus === 401 && !originalRequest._retry;

  logAxiosError(error);

  if (!tokenExpired || isRefreshingToken || !token || showSessionExpirationModal) {
    return Promise.reject(error);
  }

  // Set refresh token flag to true in order to not have multiple refresh token requests run the same time
  isRefreshingToken = true;

  originalRequest._retry = true;
  const oldRefreshToken = authService.getRefreshToken() as string;
  const response = await refreshToken(oldRefreshToken);

  // Reset refresh token flag
  isRefreshingToken = false;

  // Success token refresh
  if (response && response.status === 200) {
    authService.setTokens(response.data);
    axios.defaults.headers.common["Authorization"] = `Bearer ${response.data.access_token}`;
    return axiosApiInstance(originalRequest);

    // Error on token refresh
  } else {
    authService.removeTokens();

    if (!showSessionExpirationModal) {
      // If user used sso to login

      !isSSOLogin ? setShowSessionExpirationModal(true) : handleSSOLogout(tokenExpired);

      setShowTermsModal(false);
    }

    return Promise.reject(response);
  }
};
